import { UpdateUserProfileSettinsPayload, UserProfileDataResponseTypes, UserProfileDataTypes } from 'types/userProfile';
import baseApi, { API_V1 } from './base';

const BASE_URL = `${API_V1}/UserCustomSettings`;

const userCustomerSettingsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserCustomerSettings: build.query<UserProfileDataTypes | null, void>({
      query: () => ({
        url: `${BASE_URL}/GetUserCustomSettings`
      }),
      transformResponse: (responseData: UserProfileDataResponseTypes[]) => {
        let data: any = {};
        if (responseData) {
          responseData.forEach((field) => {
            if (field.status) {
              let options: any[] = [];
              JSON.parse(field.defaultValuesJSON).forEach((option: any) => {
                for (let id in option) {
                  options.push({
                    id,
                    value: option[id]
                  });
                }
              });
              let value: any = field.configuredPropertyValue;
              if (field.configuredPropertyKey === 'TaggingToolBar') {
                options = options.map((option) => ({ id: option.id, label: option.value }));
                if (value) {
                  value = value
                    .split(',')
                    .map((id: string) => ({ id, label: options.find((option) => option.id === id)?.label || options[0].label }));
                } else {
                  value = [];
                }
              }
              data[field.configuredPropertyKey] = {
                options,
                value: value || options[0].id,
                isEnabled: field.isEnabled
              };
            }
          });

          return data;
        }
        return null;
      },
      providesTags: ['getUserCustomerSettings'] as any
    }),
    updateUserCustomerSettings: build.mutation<void, UpdateUserProfileSettinsPayload[]>({
      query: (data) => ({
        url: `${BASE_URL}/PublishUserCustomSettings`,
        method: 'post',
        data
      }),
      invalidatesTags: ['getUserCustomerSettings'] as any
    })
  })
});

export const { useGetUserCustomerSettingsQuery, useLazyGetUserCustomerSettingsQuery, useUpdateUserCustomerSettingsMutation } =
  userCustomerSettingsApi;

export default userCustomerSettingsApi;
